import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { bootstrapLocalStorageEncryptionFromMsal } from './app/shared/utility/local-storage-bootstrap.util';
import { warnLocalStorageEncryption } from './app/shared/utility/local-storage-key-state.util';
import { installLocalStorageEncryptionShim } from './app/shared/utility/local-storage-shim.util';

installLocalStorageEncryptionShim();

void bootstrapLocalStorageEncryptionFromMsal()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(error => {
    warnLocalStorageEncryption('Angular bootstrap failed after storage encryption init', {
      error: error instanceof Error ? error.message : String(error),
    });
  });
